module.exports = __webpack_public_path__ + "img/logo11.dec03b07.png";